import { Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { BaseListeComponent } from '@classes/extends';
import { Conges, ControleUL, ControleulService as ControleULService, Eveag, Evenement, RFFerie, RFIntervalle, Sig, Utilisateur,
    UtilService as UtilisateurService } from '@estel-numerique/galaclick-api';
import { ArrayHelper, CalendrierMode, ClientHelper, DateHelper, EvenementHelper, FiltreHelper, FiltresService, ServiceHelper, TraductionCoreService,
    TypeFiltre } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';
import { isEqual } from 'date-fns';
import * as _ from 'lodash';
import { lastValueFrom } from 'rxjs';
import { FiltreAnneeMois } from 'src/app/composants';
import { AgendaEtapesEnum } from 'src/app/suiviactivite/enum/agendaEtapesEnum';
import { AgendaWebHelper } from 'src/app/suiviactivite/helpers/agendaWebHelper';
import { PlanJourEveType } from '../models/plan-jour-eve-type.model';
import { PlanJourEve } from '../models/plan-jour-eve.model';
import { PlanJour } from '../models/plan-jour.model';
import { PlanMois } from '../models/plan-mois.model';
import { PlanSemaine } from '../models/plan-semaine.model';
import { FiltreGala } from '../../../composants/composants';
import { FiltreAnneeMois as FiltreAnneeMois_1 } from '../../../composants/filtres/filtre-annee-mois/filtre-annee-mois.component';
import { SelectFiltre } from '../../../composants/select/select.component';
import { AgentActiviteDirective } from '../../../directive/directive';
import { NgClass, SlicePipe, DecimalPipe, DatePipe } from '@angular/common';
import { PlanJourAgentComponent } from '../components/plan-jour-agent/plan-jour-agent.component';



/**
  * Page des plans de tournée
  */
@Component({
    templateUrl: './plans-tournee.component.html',
    styleUrls: ['./plans-tournee.component.scss'],
    selector: 'plans-tournee',
    encapsulation: ViewEncapsulation.None,
    imports: [FiltreGala, FiltreAnneeMois_1, SelectFiltre, AgentActiviteDirective, NgClass, PlanJourAgentComponent, SlicePipe, DecimalPipe, DatePipe]
})
export class PlansTourneeComponent extends BaseListeComponent implements OnInit {
    //Composants enfant
    private wsControle = inject(ControleULService);
    private wsUtil = inject(UtilisateurService);
    private filtresService = inject(FiltresService);
    private traductionCore = inject(TraductionCoreService);

    @ViewChild('filtreAnneeMois', { static: true }) public filtreAnneeMois: FiltreAnneeMois;

    public readonly CalendrierMode = CalendrierMode;
    public moisCourant: string;

    public titre: string;
    public codeModule: string = Constantes.CodeOption.MSUIVIPLANSTOURNEE; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    protected lgTrad: Record<string, string>;

    //Liste des agents, tous organismes confondus
    private listeAgents: Utilisateur[] = [];
    public listeAgentsAffiches: Utilisateur[] = [];
    //Liste des intervalles pour le calcul des écarts
    private listeIntervalles: RFIntervalle[] = [];

    //Tableau contenant la structure de la période actuelle
    public planPeriode: PlanMois;
    // Listes des derniers résultats récupérés en base pour la période séléctionnée
    public evenementsPeriode: Evenement[];
    public evenements: Evenement[];
    public listeConges: Conges[];
    public listeFeries: RFFerie[];
    public listeControlesUL: ControleUL[];

    // Filtres
    public filtreOrga: TypeFiltre<number>[] = [];
    public filtreAgents: TypeFiltre<number>[] = [];
    public filtreServices: TypeFiltre<string>[] = [];
    public filtreStatutEve: TypeFiltre<string>[] = [];
    public filtrePlansTournee: { filtrePeriode: string, filtreOrga: number[], filtreAgents: number[], filtreServices: string[], filtreStatutEve: string[], } = {
        filtrePeriode: DateHelper.dateToAnneeMois(new Date()),
        filtreOrga: [],
        filtreAgents: [],
        filtreServices: [],
        filtreStatutEve: []
    };
    get listeElementsAff() {
        return this.getListeAffichee();
    }
    constructor() {
        super();
        this.titre = this.translate.instant("APPPLANSTOURNEE.TITRE");
        this.lgTrad = {
            PERIODE: this.translate.instant("APPPLANSTOURNEE.FILTRE.ANNEEMOIS"),
            ORGANISME: this.translate.instant("APPPLANSTOURNEE.FILTRE.ORGANISME"),
            AGENT: this.translate.instant("APPPLANSTOURNEE.FILTRE.AGENT"),
            SERVICE: this.translate.instant("APPPLANSTOURNEE.FILTRE.SERVICE"),
            STATUTEVE: this.translate.instant("APPSUIVIACTIVITE.FILTRE.STATUTEVE"),

        };
    }

    ngOnInit() {
        super.ngOnInit();
        this.init().catch(e => this.util.fErreur(e));
    }
    private async init() {
        this.util.showLoader();
        try {
            this.filtreStatutEve = AgendaWebHelper.getFiltreEvenementSuiviActivites(this.translate);
            await Promise.all([
                lastValueFrom(this.wsCacheLow.getRFIntervalle()),
                this.filtresService.getFiltreOrga(),
                this.filtresService.getFiltreRFService(),
            ]).then((results) => {
                this.listeIntervalles = results[0];
                this.filtreOrga = results[1];
                this.filtreServices = results[2];
            }).catch((error) => { throw error; });
            this.filtrer(true);
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public checkCreer() {
        return this.droitsAccess.write;
    }

    public filtrer(isRechargementNecessaire: boolean) {
        new Promise((res, rej) => {
            (async () => {
                this.util.showLoader();
                //const dernierJourMois: Date = DateHelper.dernierJourAnneeMois(this.filtrePlansTournee.filtrePeriode);
                this.listeAgents = await lastValueFrom(this.wsUtil.getUtilisateursAgent(true));
                this.appliqueFiltrePeriode();
                this.appliqueFiltreOrga();
                this.appliqueFiltreAgents();
                this.appliqueFiltreServices();
                this.appliqueFiltreStatut();
                this.filtresService.backupFiltreOrga(this.filtreOrga);

                // Récupère si nécessaire les données correspondant aux filtres actuels
                await this._recupereDonnees(isRechargementNecessaire);

                // Créé une copie de la période à afficher
                const planPeriode: PlanMois = _.cloneDeep(this.planPeriode);

                // Génère les différentes données
                this._genereJoursFeries(planPeriode);
                this._genereEvenements(planPeriode);

                // obligatoire pour forcer rebind
                this.planPeriode = _.cloneDeep(planPeriode);
            })().then(() => res(true)).catch(e => rej(e as Error));
        }).catch(e => this.util.fErreur(e)).finally(() => this.util.hideLoader());
    }


    private async _recupereDonnees(isRechargementNecessaire: boolean) {
        if (isRechargementNecessaire !== true) {
            return;
        }

        let evenements: Evenement[] = [];
        let listeControlesUL: ControleUL[] = [];
        const listeConges: Conges[] = [];
        const listeFeries: RFFerie[] = [];

        // Récupère les évènements / congés / jours fériés
        const dateDebutPeriode: Date = DateHelper.premierJourAnneeMois(this.filtrePlansTournee.filtrePeriode);
        const sDateDebutPeriode = DateHelper.dateTimeToStringForSQL(dateDebutPeriode);
        const dateFinPeriode = DateHelper.changeTimeSlotFromComponents(DateHelper.dernierJourAnneeMois(this.filtrePlansTournee.filtrePeriode), 23, 59, 59, 0);
        const sDateFinPeriode = DateHelper.dateTimeToStringForSQL(dateFinPeriode);
        const listeAgents = this.listeAgents.map(curAgent => String(curAgent.USRID));

        await Promise.all([
            this.wsUtil.getUtilAgendaPeriode(
                sDateDebutPeriode,
                sDateFinPeriode,
                listeAgents).toPromise()

        ]).then((results) => {
            evenements = results[0];

        }).catch((error) => { throw error; });
        // Récupère les numéros de cheptels des services Pesée
        // (pour récupérer les derniers contrôles et calculer les écarts)
        const listeNucheps: Set<string> = new Set<string>();
        evenements.forEach(curEvenement => {
            if (ServiceHelper.isServicePesee(curEvenement.SERVICE) === true) {
                listeNucheps.add(curEvenement.SERVICE.CLIENT.NUCHEP);
            }
        });
        // Récupère les derniers contrôles des services pesée
        if (listeNucheps.size > 0) {
            listeControlesUL = await this.wsControle.getControleULGALADerniers(Array.from(listeNucheps.values())).toPromise();
        }

        this.evenementsPeriode = evenements.filter((ev) => { return this.isEvenementMemePeriode(this.filtrePlansTournee.filtrePeriode, ev.DDEBUT); });
        this.evenements = evenements;
        this.listeControlesUL = listeControlesUL;
        this.listeConges = listeConges;
        this.listeFeries = listeFeries;
    }

    private isEvenementMemePeriode(periode: string, dEve: string) {
        if (periode && dEve) {
            const datePeriode: Date = DateHelper.fConvtoDate(DateHelper.dernierJourAnneeMois(periode));
            const dateEve = DateHelper.fConvtoDate(dEve);
            const moisPeriode = datePeriode.getMonth();
            const moisEve = dateEve.getMonth();
            const anneePeriode = datePeriode.getFullYear();
            const anneeEve = dateEve.getFullYear();
            return anneeEve == anneePeriode && moisPeriode == moisEve;

        } else {
            return null;
        }
    }

    private _genereJoursFeries(planPeriode: PlanMois) {
        // Applique l'indicateur de jour férié si on le retrouve dans la liste de référence
        planPeriode.listeJours.forEach(curJour => {
            curJour.isFerie = this.listeFeries.filter(curFerie => DateHelper.dayDiff(DateHelper.fConvtoDate(curFerie.DATEJF), curJour.date) === 0).length > 0;
        });
    }

    private _genereEvenements(planPeriode: PlanMois) {
        const agentsEve: Map<string, PlanJourEve[]> = new Map<string, PlanJourEve[]>();

        // Stocke les congés sous forme d'évènements
        this.listeConges.forEach(curConges => {
            const agentId = String(curConges.UTILISATEUR.USRID);
            const planJourEve: PlanJourEve = PlanJourEve.genereEveConge(curConges, this.filtrePlansTournee.filtrePeriode);

            const evenementsAgentCourant: PlanJourEve[] = agentsEve.get(agentId) || [];
            evenementsAgentCourant.push(planJourEve);
            agentsEve.set(agentId, evenementsAgentCourant);
        });

        // Fait de même pour les évènements classiques
        let evenements = this.evenementsPeriode;
        // Filtre selon les services retenus
        if ((this.filtrePlansTournee.filtreServices || []).length > 0) {
            const hasFiltreAucun = FiltreHelper.hasFiltreAucun(this.filtrePlansTournee.filtreServices);
            evenements = evenements.filter(curEvenement => {
                if (curEvenement.SERVICE == null) {
                    return hasFiltreAucun;
                }
                return this.filtrePlansTournee.filtreServices.includes(curEvenement.SERVICE.TYPESERVICE.CODESERV);
            });
        }

        if ((this.filtrePlansTournee.filtreStatutEve || []).length > 0) {
            evenements = evenements.filter(curEvenement => (!this.filtrePlansTournee.filtreStatutEve.includes(AgendaEtapesEnum.REALISE) && !curEvenement.dateRealise
                || (!this.filtrePlansTournee.filtreStatutEve.includes(AgendaEtapesEnum.PLANIFIE) && curEvenement.dateRealise)));
        }


        evenements.forEach(curEvenement => {
            const curClient = curEvenement.SERVICE.CLIENT;
            curEvenement.AGENTS.forEach((curAgent: Eveag) => {
                const agentId = String(curAgent.UTILISATEUR.USRID);
                // Récupère l'éventuel contrôle UL en cas de service pesée
                let dernierControleUL: ControleUL = null;
                if (ServiceHelper.isServicePesee(curEvenement.SERVICE) === true) {
                    const controlesULCibles = this.listeControlesUL.filter(curControleUL => curClient.NUCHEP === ClientHelper.getNuchepFromNumeul(curControleUL.NUMEUL));
                    if (controlesULCibles != null && controlesULCibles.length > 0) {
                        dernierControleUL = controlesULCibles[0];
                    }
                }
                // on receupere l'evenement precédent du même groupe si il a lieu avant le current evenment
                // (le premier evenement du groupe peux avoir lieu la veille donc pas le meme ddebut !)
                const evenementPrecedentFromSameGroupe = this.evenementsPeriode.find((e => { return e.GROUPEVE.IDGROUPEVE == curEvenement.GROUPEVE.IDGROUPEVE && e.DDEBUT < curEvenement.DDEBUT; }));
                const dateEvePrecedentSameGroupe = DateHelper.fConvDateTypescript(evenementPrecedentFromSameGroupe ? evenementPrecedentFromSameGroupe.DDEBUT : curEvenement.DDEBUT);
                // on recupere le dernier groupe d'evenment du controle avant le curEvenement
                const lastEve = EvenementHelper.getDerniersEvenementsAvantCtrl(curClient.IDCLIENT, this.evenements, dateEvePrecedentSameGroupe, curEvenement.GROUPEVE.IDGROUPEVE);
                const planJourEve: PlanJourEve = PlanJourEve.genereEveAgent(curEvenement, dernierControleUL, this.listeIntervalles, this.filtrePlansTournee.filtrePeriode, lastEve
                    ? lastEve[0] : null, dateEvePrecedentSameGroupe);
                const evenementsAgentCourant: PlanJourEve[] = agentsEve.get(agentId) || [];
                evenementsAgentCourant.push(planJourEve);
                agentsEve.set(agentId, evenementsAgentCourant);
            });
        });

        // Injecte les évènements dans la grille calendaire
        agentsEve.forEach((evenementsAgent: PlanJourEve[], agentId: string) => {
            // Tableau gérant les évènements en cours
            // (pour pouvoir décaler les évènements à créer sur leur bonne ligne et éviter un chevauchement)
            const plansJourEveEnCours: PlanJourEve[] = [];

            // Trie la liste des évènements par date de début
            evenementsAgent = evenementsAgent.sort((eve1, eve2) => eve1.dateDebutAff.getTime() - eve2.dateDebutAff.getTime());

            evenementsAgent.forEach(curPlanJourEve => {

                // Récupère la journée dans laquelle insérer l'évènement
                const dateDebutAff = curPlanJourEve.dateDebutAff;
                const jourCible = planPeriode.listeJours.find(planJour => isEqual(DateHelper.fConvDateTypescript(planJour.date), DateHelper.fConvDateTypescript(dateDebutAff)));
                if (jourCible == null) {
                    return;
                }
                // Récupère le tableau des agents pour la journée
                let curAgentEves = jourCible.agentsEve.get(String(agentId));
                const hasCurAgentEve = curAgentEves != null;
                if (hasCurAgentEve === false) {
                    curAgentEves = [];
                }

                // Décale l'évènement sur une ligne non occupée par un évènement en cours (pour éviter les chevauchements)
                plansJourEveEnCours.forEach((curEveEnCours, indexEveEnCours, evesEnCours) => {
                    const curEveEnCoursDFIN = new Date(curEveEnCours.dateFinAff);
                    if (
                        curEveEnCoursDFIN.getTime() < dateDebutAff.getTime() &&
                        this._isCascadeEvenementsFinie(curEveEnCours, plansJourEveEnCours, dateDebutAff)) {
                        evesEnCours.splice(indexEveEnCours, 1);
                    } else if (hasCurAgentEve === false) {
                        curAgentEves.push(PlanJourEve.genereEveVide(curEveEnCours));

                        const joursCibleEveEnCours = planPeriode.listeJours.filter(planJour => DateHelper.fConvDate(planJour.date) === DateHelper.fConvDate(curEveEnCours.dateDebutAff));
                        if (joursCibleEveEnCours != null && joursCibleEveEnCours.length !== 0) {
                            const jourCibleEvenements = joursCibleEveEnCours[0].agentsEve.get(String(agentId));
                            const hasEveVide = jourCibleEvenements.filter(curJourCibleEve => curJourCibleEve.type === PlanJourEveType.VIDE && curJourCibleEve.eveVideRef === curEveEnCours);
                            if (hasEveVide.length === 0) {
                                jourCibleEvenements.push(PlanJourEve.genereEveVide(curEveEnCours));
                            }
                        }
                    }

                });

                // Intègre l'évènement
                curAgentEves.push(curPlanJourEve);
                jourCible.agentsEve.set(String(agentId), curAgentEves);


                // Garde également une trace de cet évènement pour gérer les chevauchements
                plansJourEveEnCours.push(curPlanJourEve);
            });
        });

        // Ajuste la hauteur des différents évènements agent de chaque jour pour occuper la totalité de la hauteur
        planPeriode.listeJours.forEach(curJour => {
            curJour.agentsEve.forEach((evenementsAgent: PlanJourEve[]) => {
                let pctOccupationRestant = 100.0;
                const evenementsNonVides: PlanJourEve[] = [];
                evenementsAgent.forEach(curEvenementAgent => {
                    const isEveVide = curEvenementAgent.type === PlanJourEveType.VIDE;
                    if (isEveVide && curEvenementAgent.eveVideRef.pctOccupation != null) {
                        const pctOccupation = curEvenementAgent.eveVideRef.pctOccupation;
                        curEvenementAgent.pctOccupation = pctOccupation;
                        pctOccupationRestant = pctOccupationRestant - pctOccupation;
                    } else {
                        evenementsNonVides.push(curEvenementAgent);
                    }
                });

                const nbEvenementsNonVides = evenementsNonVides.length * 1.0;
                evenementsNonVides.forEach(curEvenementAgent => {
                    const pctOccupe = pctOccupationRestant / nbEvenementsNonVides;
                    curEvenementAgent.pctOccupation = pctOccupe;
                    if (curEvenementAgent.eveVideRef != null && curEvenementAgent.eveVideRef.pctOccupation == null) {
                        curEvenementAgent.eveVideRef.pctOccupation = pctOccupe;
                    }
                });
            });
        });
    }

    private _isCascadeEvenementsFinie(curEveEnCours: PlanJourEve, plansJourEveEnCours: PlanJourEve[], dateDebutAff: Date): boolean {
        const curEveEnCoursDDEBUT = new Date(curEveEnCours.dateDebutAff);
        const curEveEnCoursDFIN = new Date(curEveEnCours.dateFinAff);
        if (curEveEnCoursDFIN.getTime() >= dateDebutAff.getTime()) {
            return false;
        }

        // Vérifie les autres évènements en cours
        for (const curAutreEveEnCours of plansJourEveEnCours) {
            if (curAutreEveEnCours === curEveEnCours) {
                continue;
            }
            if (
                curAutreEveEnCours.dateDebut.getTime() < curEveEnCoursDFIN.getTime() &&
                curAutreEveEnCours.dateFin.getTime() >= curEveEnCoursDFIN.getTime() &&
                curAutreEveEnCours.dateDebut.getTime() > curEveEnCoursDDEBUT.getTime() &&
                !this._isCascadeEvenementsFinie(curAutreEveEnCours, plansJourEveEnCours, dateDebutAff)) {

                return false;
            }
        }

        return true;
    }

    public appliqueFiltrePeriode(periode?: string) {
        if (periode != null) {
            this.filtrePlansTournee.filtrePeriode = periode;
        }

        // Régenère le tableau des jours / semaines
        const planPeriode = new PlanMois(periode);
        const premierJourMois: Date = DateHelper.premierJourAnneeMois(this.filtrePlansTournee.filtrePeriode);
        const dernierJourMois: Date = DateHelper.dernierJourAnneeMois(this.filtrePlansTournee.filtrePeriode);
        this.moisCourant = this.filtrePlansTournee.filtrePeriode;
        let curJourMois = premierJourMois;
        let planSemaine: PlanSemaine;
        while (DateHelper.dayDiff(curJourMois, dernierJourMois) <= 0) {
            // Créé la semaine si besoin
            const numSemaine = DateHelper.numeroSemaine(curJourMois);
            if (planSemaine?.numSemaine !== numSemaine) {
                planSemaine = new PlanSemaine(numSemaine);
                planPeriode.listeSemaines.push(planSemaine);
            }
            // Créé le jour
            planSemaine.listeJours.push(new PlanJour(curJourMois, this.traductionCore));
            // Passe au jour du mois suivant
            curJourMois = DateHelper.dayAdd(curJourMois, 1);
        }
        this.planPeriode = planPeriode;
    }

    public appliqueFiltreOrga(filtreOrga?: number[]) {
        if (filtreOrga == null) {
            filtreOrga = FiltreHelper.getSelectionAsNumber(this.filtreOrga);
        }
        this.filtrePlansTournee.filtreOrga = filtreOrga;

        // On stocke les agents précédemment choisis avant d'écraser la liste des agents
        this.appliqueFiltreAgents();
        // Ajuste la liste des agents disponibles pour coller au nouveau périmètre des organisations
        const hasFiltrageOrga = FiltreHelper.isFiltrageNecessaire(this.filtreOrga);
        const listeAgentsOrga: Utilisateur[] = this.listeAgents.filter(curAgent => {
            let booOk = false;
            if (hasFiltrageOrga) {
                curAgent.LISTESIG.forEach((s: Sig) => {
                    if (this.filtrePlansTournee.filtreOrga.includes(s.IDORGA)) {
                        booOk = true;
                    }
                });
            }
            return (!hasFiltrageOrga || booOk);
        });
        this.filtreAgents = this.filtresService.getFiltreAgentsFromListe(listeAgentsOrga, this.filtreAgents);
    }

    public appliqueFiltreAgents(filtreAgents?: number[]) {
        if (filtreAgents == null) {
            filtreAgents = FiltreHelper.getSelectionAsNumber(this.filtreAgents);
        }
        this.filtrePlansTournee.filtreAgents = filtreAgents;

        // Adapte la liste des agents affichés dans le plan de tournées
        let listeIdAgentsAffiches: number[] = [];
        if (!FiltreHelper.isFiltrageNecessaire(this.filtreAgents)) {
            listeIdAgentsAffiches = this.filtreAgents.map(curFiltreAgent => Number(curFiltreAgent.value));
        } else {
            listeIdAgentsAffiches = ArrayHelper.cloneArray(this.filtrePlansTournee.filtreAgents);
        }

        const listeAgentsAffiches: Utilisateur[] = [];
        const premierJourMois: Date = DateHelper.premierJourAnneeMois(this.filtrePlansTournee.filtrePeriode);
        this.listeAgents.forEach((curAgent: Utilisateur) => {
            const indexAgentAffiche = listeIdAgentsAffiches.indexOf(curAgent.USRID);
            // On vérifie aussi que l'agent est bien actif à la période donnée
            if (indexAgentAffiche !== -1 && DateHelper.isDateDansPeriode(DateHelper.moisPrecedent(DateHelper.fConvtoDate(curAgent.DDEBUT), false), DateHelper.fConvtoDate(curAgent.DFIN),
                premierJourMois)) {
                listeAgentsAffiches.push(curAgent);
            }
        });
        this.listeAgentsAffiches = listeAgentsAffiches;
    }

    public appliqueFiltreServices(filtreServices?: string[]) {
        if (filtreServices == null) {
            filtreServices = FiltreHelper.getSelectionAsString(this.filtreServices);
        }
        this.filtrePlansTournee.filtreServices = filtreServices;
    }

    appliqueFiltreStatut(filtreStatutEve?: string[]) {
        if (filtreStatutEve == null) {
            filtreStatutEve = FiltreHelper.getSelectionAsString(this.filtreStatutEve);
        }
        this.filtrePlansTournee.filtreStatutEve = filtreStatutEve;
    }
}
